import { render, staticRenderFns } from "./CustomFormBuilder.vue?vue&type=template&id=2997f17e&scoped=true&"
import script from "./CustomFormBuilder.vue?vue&type=script&lang=ts&"
export * from "./CustomFormBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFormBuilder.vue?vue&type=style&index=0&id=2997f17e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997f17e",
  null
  
)

export default component.exports